export default "__VITE_PUBLIC_ASSET__ca761127__"